import { useMutation, useQueryClient } from "@tanstack/react-query";
import { FeedbackService } from "@/services/feedback/feedbackService";
import type { SubmitFeedbackRequest, SubmitBugReportRequest } from "@/services/feedback/feedbackService";
import { ADMIN_FEEDBACK_UNREAD_KEY } from "./useAdminFeedback";

export const FEEDBACK_QUERY_KEY = "feedback";

export function useFeedback() {
  const queryClient = useQueryClient();

  const submitFeedbackMutation = useMutation({
    mutationFn: (data: SubmitFeedbackRequest) =>
      FeedbackService.submitFeedback(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [FEEDBACK_QUERY_KEY] });
      queryClient.invalidateQueries({ queryKey: [ADMIN_FEEDBACK_UNREAD_KEY] });
    },
  });

  const submitBugReportMutation = useMutation({
    mutationFn: (data: SubmitBugReportRequest) =>
      FeedbackService.submitBugReport(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [FEEDBACK_QUERY_KEY] });
      queryClient.invalidateQueries({ queryKey: [ADMIN_FEEDBACK_UNREAD_KEY] });
    },
  });

  return {
    submitFeedback: submitFeedbackMutation.mutate,
    submitFeedbackAsync: submitFeedbackMutation.mutateAsync,
    isSubmittingFeedback: submitFeedbackMutation.isPending,
    submitFeedbackError: submitFeedbackMutation.error,

    submitBugReport: submitBugReportMutation.mutate,
    submitBugReportAsync: submitBugReportMutation.mutateAsync,
    isSubmittingBugReport: submitBugReportMutation.isPending,
    submitBugReportError: submitBugReportMutation.error,
  };
}
